import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const confirmBooking = async (data: any, booking_id: any) => {
  const result = await fetch(
    `${REACT_APP_VMS_BASE_URL}/bookings/${booking_id}/confirm`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  );
  const contacts = await result.json();
  return contacts;
};

export default confirmBooking;
